import { defineMessages } from 'react-intl';

const scope = 'app.components.aba';

export default defineMessages({
  title: {
    id: `${scope}.title`,
    defaultMessage: 'AFFILIATED BUSINESS DISCLOSURE - SELLER',
  },
  subTitleFrom: {
    id: `${scope}.subTitleFrom`,
    defaultMessage: 'From: Richr MP Holdings LLC DBA Richr Homes',
  },
  subTitleTo: {
    id: `${scope}.subTitleTo`,
    defaultMessage: 'To: The Undersigned Property Seller',
  },
  descriptionOne: {
    id: `${scope}.descriptionOne`,
    defaultMessage:
      'This is to give you notice that Richr MP Holdings LLC DBA Richr Homes (which provides real estate brokerage services) has a business relationship with  Richr Title LLC (which provides title insurance policies, title examination and settlement services), Richr Ins. Holdings LLC DBA Richr Insurance (which provides homeowners insurance) and Richr Money LLC (which is an internet investment advisor). Richr MP Holdings LLC DBA Richr Homes has an affiliate relationship with Richr Title LLC, Richr Ins. Holdings LLC DBA Richr Insurance and Richr Money LLC..',
  },
  descriptionTwo: {
    id: `${scope}.descriptionTwo`,
    defaultMessage:
      'Because of these relationships, referrals by any of these companies to one another may provide Richr MP Holdings LLC DBA Richr Homes, Richr Title  LLC, Richr Ins. Holdings LLC DBA Richr Insurance or Richr Money LLC, with a financial or other benefit. Set forth below is the estimated charge or range of charges for the settlement services listed.',
  },
  descriptionThree: {
    id: `${scope}.descriptionThree`,
    defaultMessage:
      'You are NOT required to use  the listed provider(s) as a condition for the purchase, sale, or refinance of the subject property.  THERE ARE FREQUENTLY OTHER SETTLEMENT SERVICE PROVIDERS AVAILABLE WITH SIMILAR SERVICES. YOU  ARE FREE TO SHOP AROUND TO DETERMINE THAT YOU ARE RECEIVING THE BEST SERVICES AND THE BEST  RATE FOR THESE SERVICES.',
  },
  richrTitleLLC: {
    id: `${scope}.richrTitleLLC`,
    defaultMessage: 'RICHR TITLE LLC',
  },
  titleSearchFee: {
    id: `${scope}.titleSearchFee`,
    defaultMessage: 'Title Search Fee',
  },
  searchFeeValue: {
    id: `${scope}.searchFeeValue`,
    defaultMessage: '$125 - $250',
  },
  closing: {
    id: `${scope}.closing`,
    defaultMessage: 'Closing',
  },
  closingValue: {
    id: `${scope}.closingValue`,
    defaultMessage: '$0 - $499',
  },
  ownerPolicy: {
    id: `${scope}.ownerPolicy`,
    defaultMessage: 'Owner{rsquo}s Policy of Title Insurance Promulgated rate:',
  },
  ownerPolicyValue: {
    id: `${scope}.ownerPolicyValue`,
    defaultMessage:
      '$5.75 per $1000 up to $100,000; $5.00 per $1000 up to $1,000,000; $2.50 per $1000 over $1,000,000 up to $5,000,000 ',
  },
  reIssue: {
    id: `${scope}.reIssue`,
    defaultMessage: 'Re-Issue Title Insurance Rate',
  },
  reIssueNotice: {
    id: `${scope}.reIssueNotice`,
    defaultMessage: '{nbsp}(subject to Re-issue requirements)',
  },
  reIssueValue: {
    id: `${scope}.reIssueValue`,
    defaultMessage:
      '$3.30 per $1000 up to $100,000; $3.00 per $1000 up to $1,000,000',
  },
  mortagePolicy: {
    id: `${scope}.mortagePolicy`,
    defaultMessage: 'Mortgage Policy ',
  },
  mortagePolicyNotice: {
    id: `${scope}.mortagePolicyNotice`,
    defaultMessage: '(Simultaneous issue)',
  },
  mortagePolicyValue: {
    id: `${scope}.mortagePolicyValue`,
    defaultMessage:
      '$25 up to value of Owner{rsquo}s policy and any amount over that value will be charged at the Promulgated rate above',
  },
  standardEndorsements: {
    id: `${scope}.standardEndorsements`,
    defaultMessage: 'Standard Endorsements ',
  },
  standardEndorsementsNotice: {
    id: `${scope}.standardEndorsementsNotice`,
    defaultMessage: '(each)',
  },
  standardEndorsementsValue: {
    id: `${scope}.standardEndorsementsValue`,
    defaultMessage: '$35.00 up to 10% of Combined Policy Premiums',
  },
  abaInsurance: {
    id: `${scope}.abaInsurance`,
    defaultMessage: 'RICHR INSURANCE - RESIDENTIAL POLICIES',
  },
  insuranceDescription: {
    id: `${scope}.insuranceDescription`,
    defaultMessage:
      'Premiums are based on the insurance product and may depend on location of property & type of construction, its age, credit score and past  claims of the insured.',
  },
  bottomText: {
    id: `${scope}.bottomText`,
    defaultMessage:
      'I have read this disclosure form and understand that Richr MP Holdings LLC DBA Richr Homes, Richr Title LLC and/or Richr Ins.  Holdings LLC dba Richr Insurance, is referring me to purchase the above-described service(s) and they may receive a financial or other benefit as the result of this referral. I represent that I am the owner or authorized representative of the owner(s) of the Property identified below.',
  },
  property: {
    id: `${scope}.property`,
    defaultMessage: 'Property:',
  },
  seller: {
    id: `${scope}.seller`,
    defaultMessage: 'Seller Name:',
  },
  sellerSign: {
    id: `${scope}.buyer`,
    defaultMessage: 'Seller Signature:',
  },
  date: {
    id: `${scope}.date`,
    defaultMessage: 'Date',
  },
});
